export default __webpack_public_path__ + "static/media/user-type-player-club-admin.2dba0526.svg";